module.exports = __webpack_public_path__ + "static/media/light-bulb.432109ec.svg";